import React, { useRef } from 'react';
import styles from './index.module.scss';

import { CustomToast } from 'components';
import { useAppContext } from 'utils/hooks';
import { getCustomerPortalLink } from 'utils/methods';
import { ReactComponent as LinkIcon } from 'assets/img/icons/external-link.svg';

export default function CustomerPortalLink() {
  const { supportEmail } = useAppContext();

  const customerPortalLink = useRef(getCustomerPortalLink()).current;

  const onClick = e => {
    if (!customerPortalLink) {
      e.stopPropagation();
      e.preventDefault();
      CustomToast({
        type: 'info',
        msg: `Customer Portal is not configured. Contact ${supportEmail} to get it configured.`
      });
    }
  };

  return (
    <a
      href={customerPortalLink}
      target="_blank"
      rel="noopener noreferrer"
      data-shepherd="sidebar-customer-portal"
      className={styles.container}
      onClick={onClick}
    >
      Customer Portal
      <LinkIcon />
    </a>
  );
}
